// extracted by mini-css-extract-plugin
export default {"container":"Home_container__-2ixZ","loader":"Home_loader__YTbcI","movies":"Home_movies__TFhaK"};